"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatList = void 0;
var react_1 = __importStar(require("react"));
var em_im_1 = __importDefault(require("../../../../modules/em_im"));
var store_1 = require("../store");
var mobx_react_lite_1 = require("mobx-react-lite");
// import { observer } from "mobx-react"
var chatpost_1 = require("./chatpost");
var tiptoast_1 = __importDefault(require("../../../../modules/modal/tiptoast"));
var user_1 = __importDefault(require("../../../../modules/user"));
function initEvent() {
    /**
   * IE 兼容scrollTo polyfill
   */
    if (!window.scrollTo) {
        //@ts-ignore
        window.scrollTo = function (left, top) {
            //@ts-ignore
            window.scrollLeft = left;
            //@ts-ignore
            window.scrollTop = top;
        };
    }
    if (!document.body.scrollTo) {
        //@ts-ignore
        Element.prototype.scrollTo = function (left, top) {
            this.scrollLeft = left;
            this.scrollTop = top;
        };
    }
}
var initialstate = {
    newnum: 0,
    messagelist: [],
    loading: true,
    showReplybox: false,
    replyMesId: "",
    // noticetxt: "",
    iaSwitch: false,
    shownodata: true,
    showPost: true,
    showChat: true,
    mounted: false
};
function reducer(state, action) {
    switch (action.type) {
        case "挂载完成":
            return __assign(__assign({}, state), { mounted: true });
        case "新消息数量":
            return __assign(__assign({}, state), { newnum: action.payload.newnum > 0 ? action.payload.newnum + state.newnum : 0 });
        case "消息列表":
            return __assign(__assign({}, state), { messagelist: state.messagelist.concat(action.payload.messagelist) });
        case "加载中":
            return __assign(__assign({}, state), { loading: action.payload.loading });
        case "显示回复框":
            return __assign(__assign({}, state), { showReplybox: action.payload.showReplybox, replyMesId: action.payload.replyMesId });
        // case "公告":
        //   return {
        //     ...state,
        //     noticetxt: action.payload.noticetxt
        //   }
        case "禁止互动":
            return __assign(__assign({}, state), { iaSwitch: action.payload.iaSwitch });
        case "没有数据":
            return __assign(__assign({}, state), { shownodata: action.payload.shownodata });
        default:
            throw new Error();
    }
}
/**
 * 聊天列表
 * @returns
 */
exports.ChatList = (0, mobx_react_lite_1.observer)(function (props) {
    var _a;
    var _b, _c, _d, _e;
    var chatbox = (0, react_1.useRef)(null); // 互动框 
    var hasnew = (0, react_1.useRef)(null); // 新消息提醒
    var state = (_a = (0, react_1.useReducer)(reducer, initialstate), _a[0]), dispatch = _a[1];
    var status = props.baseinfo.status;
    //是否展示聊天 0 默认开启 1关闭
    var ia_switch = (_c = (_b = props.baseinfo) === null || _b === void 0 ? void 0 : _b.intercation_config) === null || _c === void 0 ? void 0 : _c.ia_switch;
    var authcode = (_e = (_d = props === null || props === void 0 ? void 0 : props.authinfo) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.code;
    // console.log(toJS(props.thisuser))
    if (status == null)
        return (react_1.default.createElement(react_1.default.Fragment, null));
    (0, react_1.useEffect)(function () {
        initEvent();
        bindEvent();
        bindIMEvent();
    }, []);
    (0, react_1.useEffect)(function () {
        // 关闭互动区 或者 回顾认证不通过  不展示互动 ||   需要预约情况
        if (ia_switch === 1 || (status == 3 && authcode != 0 && authcode != 42110) || store_1.luyanstore.authBtnEvents.needauth) {
            dispatch({
                type: "加载中",
                payload: { loading: false }
            });
            dispatch({
                type: "禁止互动",
                payload: {
                    iaSwitch: true
                }
            });
            store_1.luyanstore.forbidChat = true;
            return;
        }
        // alert(luyanstore.authBtnEvents.needyuyue)
        // 暂无数据模块展示
        // if(luyanstore.authBtnEvents.needyuyue){
        //   dispatch({
        //     type: "没有数据",
        //     payload: { shownodata: true }
        //   })
        // }
        // 开启互动
        if (!ia_switch) {
            dispatch({
                type: "加载中",
                payload: { loading: true }
            });
            getHistory();
        }
    }, [props.baseinfo.status, store_1.luyanstore.authBtnEvents.needauth]);
    /**
     * 获取历史信息
     */
    var getHistory = function () { return __awaiter(void 0, void 0, void 0, function () {
        var messages;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    dispatch({
                        type: "加载中",
                        payload: { loading: true }
                    });
                    messages = [];
                    if (!(status == 3)) return [3 /*break*/, 2];
                    return [4 /*yield*/, em_im_1.default.getChannelMessagesForPri({})];
                case 1:
                    messages = (_d.sent()).reverse();
                    return [3 /*break*/, 4];
                case 2:
                    if (!(status == 1 || status == 4)) return [3 /*break*/, 4];
                    return [4 /*yield*/, em_im_1.default.getMessageList()];
                case 3:
                    messages = _d.sent();
                    _d.label = 4;
                case 4:
                    // console.log(messages)
                    dispatch({
                        type: "加载中",
                        payload: { loading: false }
                    });
                    dispatch({
                        type: "消息列表",
                        payload: {
                            messagelist: messages
                        }
                    });
                    if (messages.length) {
                        scrollBottom();
                    }
                    if (status != 3) {
                        insertNotice((_c = (_b = (_a = props.baseinfo) === null || _a === void 0 ? void 0 : _a.config) === null || _b === void 0 ? void 0 : _b.notice) === null || _c === void 0 ? void 0 : _c.content);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    /**
     * 滚到最底部
     */
    var scrollBottom = function () {
        var _a, _b;
        (_b = (_a = $(chatbox.current)) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.scrollTo(0, 100000000);
    };
    /**
     * 插入一条新消息
     * @param data
     */
    var insetNewMessage = function (data) {
        if (data === void 0) { data = []; }
        em_im_1.default.dealOneMessage(data);
        //是否已经在最底下了
        var isscrollbottom = false;
        if ($(chatbox.current)[0].scrollTop + $(chatbox.current)[0].offsetHeight + 10 >= $(chatbox.current)[0].scrollHeight) {
            isscrollbottom = true;
        }
        var iscroll = false; //是否要自动滚动到最底下
        if (data.isSelf || isscrollbottom) { //如果是自己的发言 或者已经在最底下 直接滚动到最下面
            iscroll = true;
        }
        dispatch({
            type: "消息列表",
            payload: {
                messagelist: data
            }
        });
        if (iscroll) {
            scrollBottom();
        }
        // 新消息提醒
        if (!isscrollbottom && !iscroll) {
            dispatch({
                type: "新消息数量",
                payload: { newnum: 1 }
            });
        }
    };
    /**
     * 绑定im事件
     */
    var bindIMEvent = function () {
        // 获取新消息
        em_im_1.default.regGetNewMessage(function (data) {
            if (data === void 0) { data = []; }
            insetNewMessage(data);
        });
        /**
         * 插入公告
         */
        em_im_1.default.onNotice(function (notice_txt) {
            insertNotice(notice_txt);
        });
    };
    /**
     * 绑定dom 事件
     */
    var bindEvent = function () {
        // 空白区域点击事件
        // $(document).on('click', function (e) {
        //   let thisdom = $(e.target)
        //   if (thisdom.parents('.replyform').length == 0 && thisdom.parent(".replybtn").length < 1) {
        // dispatch({
        //   type: "显示回复框",
        //   payload: {
        //     showReplybox: false,
        //     replyMesId: ""
        //   }
        // })
        //     }
        //   })
    };
    /**
     * 查看新消息
     * @param e
     */
    var viewNews = function (e) {
        e.preventDefault();
        scrollBottom();
        dispatch({
            type: "新消息数量",
            payload: { newnum: 0 }
        });
    };
    /**
     * 插入一条公告
     * @param notice_txt
     * @returns
     */
    var insertNotice = function (notice_txt) {
        if (!notice_txt)
            return false;
        insetNewMessage({
            isNotice: true,
            notice_txt: notice_txt,
            Sender: {
                UserID: "", Nick: ""
            },
            SendDateTime: Math.ceil((new Date()).getTime() / 1000),
            Content: { txt: notice_txt },
            QuoteMessage: ""
        });
        // dispatch({
        //   type: "公告",
        //   payload: {
        //     noticetxt: notice_txt
        //   }
        // })
    };
    var onClickBtn = function (e) {
        e.preventDefault();
        store_1.luyanstore.authBtnEvents.onBtnFun && store_1.luyanstore.authBtnEvents.onBtnFun(null);
    };
    // if(!state.mounted) return <></>
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "chat-newbox" },
            react_1.default.createElement("div", { className: "luyan_wrap" },
                react_1.default.createElement("div", { className: "luyan_nav" },
                    react_1.default.createElement("div", { className: "luyan_top" },
                        react_1.default.createElement("h3", { className: "tit" }, "\u4E92\u52A8\u4EA4\u6D41"))),
                react_1.default.createElement("div", { ref: chatbox, className: "luyan_content", id: "luyan_content" },
                    state.loading && react_1.default.createElement("ul", { className: "loading" }),
                    store_1.luyanstore.authBtnEvents.needauth && !state.loading &&
                        react_1.default.createElement(CheckButtonBlock, { authcode: authcode, onClickBtn: onClickBtn }),
                    !store_1.luyanstore.authBtnEvents.needauth && react_1.default.createElement(react_1.default.Fragment, null,
                        !state.loading && (!state.messagelist.length || !store_1.luyanstore.showChatList) &&
                            react_1.default.createElement("div", { id: "nochatdata", className: "nochatdata" }),
                        !state.loading && state.messagelist.length > 0 && store_1.luyanstore.showChatList &&
                            react_1.default.createElement(react_1.default.Fragment, null,
                                !!state.newnum &&
                                    react_1.default.createElement("div", { ref: hasnew, id: "hasnew", onClick: function (e) { viewNews(e); } },
                                        react_1.default.createElement("span", { className: "downarray" }),
                                        react_1.default.createElement("em", null, state.newnum),
                                        "\u6761\u65B0\u6D88\u606F"),
                                react_1.default.createElement("ul", null, state.messagelist.map(function (v, i) {
                                    return (react_1.default.createElement(react_1.default.Fragment, { key: v.MsgID + '' + i },
                                        !v.isNotice &&
                                            react_1.default.createElement(MemoizedListItem, { state: state, data: v, thisuser: props.thisuser, baseinfo: props.baseinfo, insetNewMessage: insetNewMessage }),
                                        v.isNotice &&
                                            react_1.default.createElement("li", { className: "item_notice" },
                                                react_1.default.createElement("div", null,
                                                    react_1.default.createElement("span", { className: "notice_title" }, "\u76F4\u64AD\u516C\u544A\uFF1A"),
                                                    v.Content.txt))));
                                })))))),
            status != 3 && !store_1.luyanstore.forbidChat && !store_1.luyanstore.authBtnEvents.needauth && store_1.luyanstore.showChatPost &&
                react_1.default.createElement(chatpost_1.PostChatBox, { sendCallback: insetNewMessage, baseinfo: props.baseinfo }))));
});
/**
 * 预约 报名 等校验 按钮
 * @param props
 * @returns
 */
var CheckButtonBlock = function (props) {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("ul", null,
            react_1.default.createElement("div", { className: "yy-wrap" },
                react_1.default.createElement("div", { id: "ly-yybg", className: "ly-yybg" }, props.authcode == 44000 && react_1.default.createElement("div", { className: 'tips' },
                    react_1.default.createElement("p", null, "\u67E5\u770B\u98CE\u9669\u63D0\u793A"),
                    react_1.default.createElement("p", null, "\u89E3\u9501\u76F4\u64AD"))),
                react_1.default.createElement("a", { onClick: function (e) { props.onClickBtn(e); }, className: "yybtn bt2 ".concat(store_1.luyanstore.authBtnEvents.rightBtnClass || ""), id: "ly_chat_yybtn", style: { cursor: "pointer" } }, props.authcode == 44000 ? "去查看" : store_1.luyanstore.authBtnEvents.btntxt)))));
};
/**
 * 互动单条消息
 * @param props
 * @returns
 */
var ChatItemComponent = function (props) {
    var _a, _b, _c, _d, _e, _f;
    var _g = (0, react_1.useState)(false), showReplybox = _g[0], setShowReplyBox = _g[1];
    var _h = (0, react_1.useState)(""), replyMesId = _h[0], setReplyMesId = _h[1]; // 当前执行回复的msg
    var replyform_txt = (0, react_1.useRef)(null); // 回复框
    /**
     * 回复点击事件
     * @param e
     * @param v
     * @returns
     */
    var onReplyFun = function (e, v) {
        var _a;
        setShowReplyBox(false);
        setReplyMesId("");
        if (!((_a = user_1.default.get()) === null || _a === void 0 ? void 0 : _a.id))
            return false;
        e.preventDefault();
        if ((window === null || window === void 0 ? void 0 : window.CertifiedType) == '-1') {
            tiptoast_1.default.show({
                content: "您尚未进行身份认证，请认证后发言！",
                callack: function () { }
            });
            return false;
        }
        ;
        setShowReplyBox(true);
        setReplyMesId(v.MsgID);
        $(replyform_txt.current).focus();
    };
    /**
     * 回复发送事件
     * @param e
     * @param data
     * @returns
     */
    var onSendReplyFun = function (e, data) { return __awaiter(void 0, void 0, void 0, function () {
        var reply_text, message, aliasname;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    // props.onSendReply(e, v.MsgID)
                    e.preventDefault();
                    reply_text = $.trim($(replyform_txt.current).val());
                    if (reply_text == "") {
                        return [2 /*return*/, false];
                    }
                    message = data || "";
                    return [4 /*yield*/, em_im_1.default.sendNewQuoteMessage(reply_text, message)
                        // 白名单自定义名称
                    ];
                case 1:
                    _d.sent();
                    aliasname = props.baseinfo.view_type == 4 ? (_a = props.baseinfo.user) === null || _a === void 0 ? void 0 : _a.alias : "";
                    props.insetNewMessage({
                        Sender: {
                            UserID: (_b = user_1.default.get()) === null || _b === void 0 ? void 0 : _b.id,
                            Nick: aliasname || ((_c = user_1.default.get()) === null || _c === void 0 ? void 0 : _c.nick)
                        },
                        SendDateTime: Math.ceil((new Date()).getTime() / 1000),
                        Content: {
                            txt: reply_text
                        },
                        QuoteMessage: message
                    });
                    setShowReplyBox(false);
                    setReplyMesId("");
                    return [2 /*return*/];
            }
        });
    }); };
    var v = props.data;
    var presenters = ((_a = props.baseinfo) === null || _a === void 0 ? void 0 : _a.presenters) || [];
    var guests = ((_b = props.baseinfo) === null || _b === void 0 ? void 0 : _b.guests) || [];
    //是否是主持人
    v.ishost = false;
    if (presenters && presenters.length > 0) {
        v.ishost = presenters.some(function (c) {
            var _a;
            return c.emuid == ((_a = v === null || v === void 0 ? void 0 : v.Sender) === null || _a === void 0 ? void 0 : _a.UserID);
        });
    }
    //是否是嘉宾
    v.isguest = false;
    if (guests && guests.length > 0) {
        v.isguest = guests.some(function (c) {
            var _a;
            if (c.emuid == ((_a = v === null || v === void 0 ? void 0 : v.Sender) === null || _a === void 0 ? void 0 : _a.UserID)) {
                v.guestinfo = c === null || c === void 0 ? void 0 : c.position;
                return true;
            }
            else {
                return false;
            }
        });
    }
    // 不是我的私信
    if (v.type == 'nomyprivate') {
        return react_1.default.createElement(react_1.default.Fragment, null);
    }
    // 失去焦点隐藏
    var onblurFun = function () {
        setTimeout(function () {
            setShowReplyBox(false);
            setReplyMesId("");
        }, 160);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        v.showtime && react_1.default.createElement("div", { className: "item_time" },
            react_1.default.createElement("span", null, v.showtime)),
        react_1.default.createElement("li", { className: v.isSelf ? "item itemself" : "item" },
            react_1.default.createElement("div", { className: "avater" },
                react_1.default.createElement("img", { src: "https://avatar.eastmoney.com/qface/".concat(v.Sender.UserID, "/50"), alt: "" })),
            react_1.default.createElement("div", { className: "info" },
                v.isguest && react_1.default.createElement("span", { className: "guestinfo" }, v.guestinfo || ""),
                react_1.default.createElement("span", { className: "name" }, ((_c = v.Sender) === null || _c === void 0 ? void 0 : _c.Nick) || ""),
                v.ishost && react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", { className: "sx" }, "|"),
                    react_1.default.createElement("span", { className: "lab" }, "\u4E3B\u6301\u4EBA")),
                v.isguest && react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement("span", { className: "sx" }, "|"),
                    react_1.default.createElement("span", { className: "lab" }, "\u5609\u5BBE")),
                v.type == 'private' && react_1.default.createElement("span", { className: "privatemessage" },
                    react_1.default.createElement("span", null, "\u79C1\u4FE1"),
                    " \u6211")),
            react_1.default.createElement("div", { className: "answer_con" },
                react_1.default.createElement("span", { className: "hover ".concat(v.type == "private" ? "private" : "", " ").concat(v.isSelf ? "arrow-box-right" : "arrow-box") },
                    v.Content.txt,
                    v.type == 'reply' && react_1.default.createElement("div", { className: "reply" },
                        react_1.default.createElement("b", null,
                            ((_d = v.QuoteMessage.Sender) === null || _d === void 0 ? void 0 : _d.Nick) || "",
                            "\uFF1A"),
                        ((_e = v.QuoteMessage.Content) === null || _e === void 0 ? void 0 : _e.txt) || ""),
                    !!((_f = props.thisuser) === null || _f === void 0 ? void 0 : _f.id) && !v.isSelf && v.type != 'reply' && v.type != 'private' && user_1.default.get() != null && props.baseinfo.status != 3 &&
                        react_1.default.createElement(react_1.default.Fragment, null,
                            showReplybox && replyMesId == v.MsgID &&
                                react_1.default.createElement("div", { className: "replyform" },
                                    react_1.default.createElement("textarea", { name: "", ref: replyform_txt, className: "replyform_txt", onBlur: onblurFun, autoFocus: true, cols: 30, rows: 10 }),
                                    react_1.default.createElement("a", { hrefLang: "javascript:", className: "replyform_sendbtn", target: "_self", onClick: function (e) { onSendReplyFun(e, v); } }, "\u53D1\u9001")),
                            !showReplybox &&
                                react_1.default.createElement("div", { className: "replybtn" },
                                    react_1.default.createElement("a", { hrefLang: "javascript:;", target: "_self", onClick: function (e) { onReplyFun(e, v); } }, "\u56DE\u590D"))))))));
};
/**
 * memo组件
 */
var MemoizedListItem = (0, react_1.memo)(ChatItemComponent, function (oldobj, newobj) {
    var _a, _b;
    return ((_a = oldobj.data) === null || _a === void 0 ? void 0 : _a.MsgID) === ((_b = newobj.data) === null || _b === void 0 ? void 0 : _b.MsgID);
});
//# sourceMappingURL=data:application/json;base64,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